<div *ngIf="theme !== 'material'" class="inputMainWrap {{theme}}" [ngClass]="customClass">
  <div *ngIf="label" class="label" [innerHTML]="label"></div>
  <div class="inputWrap" [ngClass]="{'inputError': control?.invalid && control?.touched, 'read-only': disabled}">
    <ng-template *ngIf="allCountries" [ngTemplateOutlet]="countryDropdown"></ng-template>
    <div class="seperate"></div>
    <input *ngIf="control" #childInput
      [id]="inputId"
      [type]="isMobile ? 'tel' : 'text'"
      [placeholder]="placeHolder"
      [formControl]="control"
      (focus)="focusInput(true)"
      (focusout)="focusInput(false)"
      (wheel)="$event.preventDefault()"
      min="0"
      [readonly]="disabled"
    />
    <em *ngIf="showEdit" class="material-icons edit" (click)="onEditClick.emit($event)">edit</em>
    <em *ngIf="!showEdit && showIcon" class="material-icons phone">phone</em>
  </div>
  <div *ngIf="control?.touched && control?.hasError('required')" class="error" [innerHTML]="errorMessage?.required"></div>
  <div *ngIf="control?.touched && control?.hasError('pattern')" class="error" [innerHTML]="errorMessage?.custom"></div>
  <div *ngIf="note" class="note" [innerHTML]="note"></div>
</div>

<div *ngIf="control && theme === 'material'" class="inputMainWrap {{theme}}" [ngClass]="customClass">
  <ng-template *ngIf="allCountries" [ngTemplateOutlet]="countryDropdown"></ng-template>
  <mat-form-field class="phoneField" [formGroup]="group">
    <mat-label>{{'Stories.donations.phone' | translatePipe | async}}</mat-label>
    <input matInput #childInput [type]="isMobile ? 'tel' : 'text'" [formControl]="control">
    <mat-icon *ngIf="!hideSuffix" class="icon-phone" matSuffix></mat-icon>
    <mat-error *ngIf="control?.touched && control?.invalid">{{'Stories.donations.enterValidPhone' | translatePipe | async}}</mat-error>
    <mat-hint>{{'Stories.donations.allpayment' | translatePipe | async}}</mat-hint>
  </mat-form-field>
</div>


<ng-template #countryDropdown>
  <button type="button" class="selectedBtn" [matMenuTriggerFor]="countryMenu" [disabled]="disabled || control?.disabled" mat-ripple>
    <div *ngIf="theme !== 'material'" class="dial-code">{{selectedCountry?.dialCode}}</div>
    <em *ngIf="theme !== 'material'" class="material-icons">keyboard_arrow_down</em>
    <div *ngIf="theme === 'material'" class="flag"><img loading="lazy" [attr.data-src]="vars.getFlagPath(selectedCountry?.code, 80)" alt=""></div>
    <em *ngIf="theme === 'material'" class="material-icons">arrow_drop_down</em>
  </button>
  <mat-menu #countryMenu="matMenu" class="countryDropdown">
    <button *ngFor="let item of allCountries" type="button" [ngClass]="{'active': item.code === selectedCountry?.code}" (click)="setCountry(item)" mat-menu-item><img loading="lazy" [attr.data-src]="vars.getFlagPath(item?.code, 80)" alt=""><span>{{item?.name}}&nbsp;</span> <span *ngIf="item?.nameLang">({{item?.nameLang}})&nbsp;</span> <span class="dialCode">{{item.dialCode}}</span></button>
  </mat-menu>
</ng-template>